// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__d_AHJ","bigColWidth":"Table_bigColWidth__3G9jx","biggerColWidth":"Table_biggerColWidth__7KYmk","row":"Table_row__1LCSl","col":"Table_col__WmnBK"};